import { change } from 'redux-form';
import { createPartnershipFormFields } from 'constants/formFields';
import { formNamesPartnership } from 'constants/forms';
export const clearCreatePartnershipInviteMessage = (formName = formNamesPartnership.CREATE) => change(formName, createPartnershipFormFields.INVITE_MESSAGE, '');
export const changeCreatePartnershipFormSubmitted = (formName = formNamesPartnership.CREATE, newValue = true) => change(formName, createPartnershipFormFields.UI_FORM_SUBMITTED, newValue);
